import type React from 'react';

function DAOLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 320.19 164.09"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>DAO Logo</title>

      <g id="Layer_2-2" data-name="Layer 2">
        <g>
          <path
            d="M300.51,66.99c-7.18-3.97-22.69-4.17-31.03-4.17s-23.85,.19-31.03,4.17c-18.72,10.23-19.68,32.72-19.68,46.35s.96,36.35,19.68,46.54c7.18,3.97,22.69,4.17,31.03,4.17s23.85-.19,31.03-4.17c18.72-10.23,19.68-32.72,19.68-46.54s-.93-36.12-19.68-46.35m-21.19,66.99c-2.47,1.31-6.98,1.51-9.84,1.51s-7.37-.19-9.84-1.51c-4.55-2.66-4.75-11.92-4.75-20.8s.19-17.6,4.75-20.26c2.47-1.31,6.98-1.51,9.84-1.51s7.37,.19,9.84,1.51c4.55,2.66,4.75,11.54,4.75,20.26s-.19,18.18-4.75,20.8Z"
            fill="inherit"
          />
          <path
            d="M101.42,62.79V0h-19.68c-10.27,0-16.44,10.3-16.44,20.3V63.25c-4.9-.35-11.08-.39-14.59-.39-8.34,0-23.85,.19-31.03,4.17C.96,77.22,0,99.76,0,113.38s.96,36.35,19.68,46.54c7.18,3.97,22.69,4.17,31.03,4.17s23.85-.19,31.03-4.17c18.72-10.23,19.68-32.72,19.68-46.54,0-1.89-.04-3.94-.12-6.1l.12-44.5m-40.87,71.2c-2.47,1.31-6.98,1.51-9.84,1.51s-7.37-.19-9.84-1.51c-4.55-2.66-4.75-11.92-4.75-20.8s.19-17.6,4.75-20.26c2.47-1.31,6.98-1.51,9.84-1.51s7.37,.19,9.84,1.51c4.55,2.66,4.75,11.54,4.75,20.26s-.19,18.18-4.75,20.8Z"
            fill="inherit"
          />
          <path
            d="M210.4,92.35c0-15.9-13.39-29.1-30.6-29.1h-20.14c-8.34,0-23.85-.19-31.03,3.78-18.72,10.23-19.68,32.72-19.68,46.35s.96,36.35,19.68,46.54c5.87,3.24,15.67,4.01,24.2,4.17,20.49,.04,21.42-18.6,21.42-18.6,0,7.14,6.06,18.6,17.4,18.6h18.72l.04-61.24v-10.5m-40.91,41.64c-2.47,1.31-6.98,1.51-9.84,1.51s-7.37-.19-9.84-1.51c-4.55-2.66-4.75-11.92-4.75-20.8s.19-17.6,4.75-20.26c2.47-1.31,6.98-1.51,9.84-1.51s7.37,.19,9.84,1.51c4.55,2.66,4.75,11.54,4.75,20.26s-.19,18.18-4.75,20.8Z"
            fill="inherit"
          />
        </g>
      </g>
    </svg>
  );
}

export default DAOLogo;
